module.exports = __webpack_public_path__ + "media/src/application/media/svg/abstract-shapes-20-b464306ff37959fd5afc6ce85d5a0cfb.svg";